import * as React from 'react';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { OnboardingModal } from '../OnboardingModal';
import { ROUTE_PATH } from '../../../constants';
import { useBooleanState } from '../../../hooks';
import { ONBOARDING_THUNK_ACTIONS } from '../../../actions/onboarding';
import { sessionSelector } from '../../../reducers/session';

const TKO_TEXT = (
  <p>
    You may now submit your information for review. After submission you will be
    contacted to schedule your Technical Kickoff Call, a meeting with your
    Onboarding team to review your organization's technical details.
  </p>
);
const FOLLOWUP_TEXT = (
  <p>
    You may now submit your information for review. After submission, your
    Onboarding team will review your organization's technical details and
    schedule a follow-up call if necessary.
  </p>
);

export const useSubmitModal = () => {
  const dispatch = useDispatch();

  const [isOpen, , openModal, cancelModal] = useBooleanState(false);

  const TKOCompleted = useSelector(sessionSelector.hasCompletedTKO);

  const submitData = React.useCallback(() => {
    dispatch(ONBOARDING_THUNK_ACTIONS.SUBMIT_ONBOARDING_DATA());
    cancelModal();
  }, [cancelModal, dispatch]);

  const modal = (
    <OnboardingModal
      visible={isOpen}
      title="Submit Information"
      onCancel={cancelModal}
      onOk={submitData}
      okTitle="Submit"
    >
      <div style={{ width: '570px' }} data-cy="confirm-text">
        {TKOCompleted ? FOLLOWUP_TEXT : TKO_TEXT}
        <p>
          Once submitted <b>your details will become read-only</b> in order to
          facilitate the review process. You will have the opportunity to modify
          your details during the call.
        </p>
        Please <Link to={ROUTE_PATH.CONTACT}>contact your Onboarding Team</Link>{' '}
        if you have questions before the call.
      </div>
    </OnboardingModal>
  );

  return {
    modal,
    openModal,
  };
};
